// The public face at "/" for logged-out visitors. Deliberately minimal — it
// reveals nothing about the app and offers no login. The only way through is
// the easter egg: tap the "CoinHealth" wordmark 10 times, with the 1st and
// 10th taps inside a 10-second window, to reach the install page.

const EGG_TAPS = 10;
const EGG_WINDOW_MS = 10_000;

interface ComingSoonOpts {
  /** Fired when the 10-tap easter egg completes. */
  onEasterEgg: () => void;
}

export function comingSoonScreen(opts: ComingSoonOpts): HTMLElement {
  const root = document.createElement('div');
  root.style.cssText = `
    min-height: 100vh; box-sizing: border-box;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    text-align: center; padding: 2rem;
    background: #0f1923; color: #e0e0e0;
  `;

  const icon = document.createElement('span');
  icon.textContent = '$';
  icon.style.cssText = `
    font-size: 3rem; color: #2d8a5e; font-weight: 700;
    font-family: 'SF Mono', 'Fira Code', monospace;
    line-height: 1; margin-bottom: 1rem;
  `;

  // The tappable wordmark. No pointer cursor — the easter egg stays hidden.
  const wordmark = document.createElement('h1');
  wordmark.textContent = 'CoinHealth';
  wordmark.style.cssText = `
    font-size: 2rem; font-weight: 700; color: #e0e0e0;
    margin: 0 0 0.5rem; letter-spacing: -0.5px;
    user-select: none; -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent; touch-action: manipulation;
  `;

  const tagline = document.createElement('p');
  tagline.textContent = 'Coming soon';
  tagline.style.cssText = 'color: #8899aa; font-size: 1rem; margin: 0 0 0.35rem; font-weight: 500;';

  const sub = document.createElement('p');
  sub.textContent = 'A calmer way to see your money. We’re putting on the finishing touches.';
  sub.style.cssText = 'color: #6b7f8e; font-size: 0.85rem; line-height: 1.5; max-width: 320px; margin: 0;';

  root.append(icon, wordmark, tagline, sub);

  // Sliding window of the last EGG_TAPS tap times. When it is full and the
  // oldest of those taps is within EGG_WINDOW_MS of the newest, the egg fires.
  // Old taps naturally age out, so a lapsed window resets itself.
  const taps: number[] = [];
  // pointerdown unifies mouse + touch + pen (one event per tap, no 300ms delay,
  // no double-counting from the synthesized click that follows a touch).
  wordmark.addEventListener('pointerdown', () => {
    const now = Date.now();
    taps.push(now);
    if (taps.length > EGG_TAPS) taps.shift();
    if (taps.length === EGG_TAPS && now - taps[0] <= EGG_WINDOW_MS) {
      taps.length = 0;
      opts.onEasterEgg();
    }
  });

  return root;
}
